module.exports = require("@swa-ui/placements/src/BannerGrid/BannerGridLayout2.module.scss");